import { initializeAudioStateEvents } from './audioEvents';
import { initializeDisplayEvents } from './displayStateEvents';
import { initializeDriverEvents } from './driverEvents';
import { initializeGamepadEvents } from './gamepadEvents';
import { initializeGlobalInputEvents } from './globalInputEvents';
import { initializeHostEvents } from './hostEvents';
import { initializeInvitationSendEvents } from './invitationSendEvents';
import { initializeLoginProfileEvents } from './loginProfileEvents';
import { initializeMicrophoneSelectionEvents } from './microphoneSelection';
import { initializePlayerEvents } from './playerEvents';
import { initializeQrEvents } from './qrEvents';
import { initializeQueueEvents } from './queueEvents';
import { initializeStaticImageEvents } from './staticImageEvents';
import { initializeVideoStateEvents } from './videoEvents';
import { initializeTwitchSettingsEvents } from './twitchSettingsEvents';
import { initializeIceServerEvents } from './iceServerEvents';
import { initializeHostGamepadEvents } from './hostGamepadEvents';
// import { initializePauseInputEvents } from './pauseInputEvents';
import { initializeHostMatchmakingEvents } from './hostMatchmakingEvents';
import { initializeInputHandlerEvents } from './inputHandlerEvents';
import { initializePlayjectorHostModeEvents } from './playjectorHostModeEvents';
import { networkMetricsState } from '../../stores/shared';
import { pingClient, bandwidthClient } from '@playcastdotio/PingClient';
import { initializeNetworkEvents } from './networkEvents';
import { initializeMatchmakerEvents } from './matchmakerEvents';
import { initializeHostInputDominanceEvents } from './hostInputDominance';
import { initializeInvitationEvents } from './invitationEvents';
export const initializeElectronEvents = () => {
  initializeLoginProfileEvents();
  initializeGlobalInputEvents();
  initializeMicrophoneSelectionEvents();
  initializePlayerEvents();
  initializeVideoStateEvents();
  initializeGamepadEvents();
  initializeHostGamepadEvents();
  initializeDisplayEvents();
  initializeHostEvents();
  initializeAudioStateEvents();
  initializeDriverEvents();
  initializeStaticImageEvents();
  initializeQueueEvents();
  initializeInvitationSendEvents();
  initializeTwitchSettingsEvents();
  initializeIceServerEvents();
  // initializePauseInputEvents();
  initializeHostMatchmakingEvents();
  initializeInputHandlerEvents();
  initializeNetworkEvents();
  initializeMatchmakerEvents();
  initializePlayjectorHostModeEvents();
  initializeHostInputDominanceEvents();
  initializeInvitationEvents();
};

export const initializeRemoteEvents = () => {
  initializeLoginProfileEvents();

  // Theres not a good place to put this, so it lives here now.
  // pingClient.initialize(10 * 1000, (results) => {
  //   console.log('[IPC-Fns] Ping results', results);
  //   networkMetricsState.updateState({
  //     ...networkMetricsState.currentState,
  //     ping: results,
  //   });
  // });
  // pingClient.start();

  // bandwidthClient.initialize({
  //   interval: 60 * 1000,
  //   callback: (results) => {
  //     console.log('[IPC-Fns] Bandwidth results', results);
  //     networkMetricsState.updateState({
  //       ...networkMetricsState.currentState,
  //       bandwidth: results,
  //     });
  //   },
  // });
  // bandwidthClient.start();
};

// Redundant events:
// initialzeQrEvents()
